module.exports = __webpack_public_path__ + "img/color-picker.e7c1475f.svg";